"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var body_scroll_lock_1 = require("body-scroll-lock");
var hammerjs_1 = __importDefault(require("hammerjs"));
exports.chille = function () {
    var places_items = document.querySelectorAll('.place-content');
    var contact = document.querySelector('.kontakt__padding');
    var contact_links = document.querySelectorAll('.kontakt a');
    var place_links = document.querySelectorAll('.place a');
    var toggleClass = function (e) {
        document.body.classList.remove('contact--is-expanded');
        document.body.classList.toggle('place--is-expanded');
    };
    var contactToggle = function () {
        document.body.classList.remove('place--is-expanded');
        document.body.classList.toggle('contact--is-expanded');
    };
    var preventPropagation = function (e) { return e.stopPropagation(); };
    contact_links.forEach(function (link) { return link.addEventListener('click', preventPropagation); });
    place_links.forEach(function (link) { return link.addEventListener('click', preventPropagation); });
    places_items.forEach(function (place) { return place.addEventListener('click', toggleClass); });
    contact.addEventListener('click', contactToggle);
};
var ChilleLazy = /** @class */ (function () {
    function ChilleLazy() {
        this.prev = document.querySelector('.pnav-left');
        this.next = document.querySelector('.pnav-right');
        this.nav = document.querySelector('.places__nav');
        this.items = document.querySelectorAll('.place');
        this.count = this.items.length;
        this.touchSupport = document.documentElement.classList.contains('touchevents');
        this.activeIndex = 0;
        this.init();
    }
    ChilleLazy.prototype.init = function () {
        this.addEvents();
        this.lazyImage();
        this.setActive(this.activeIndex);
    };
    ChilleLazy.prototype.setActive = function (index) {
        var prev_before = this.getPrevIndex();
        var next_before = this.getNextIndex();
        this.items[this.activeIndex].classList.remove('is-active'); // remove ActiveClass
        this.activeIndex = index; // Set active index
        this.lazyImage();
        var prev_after = this.getPrevIndex();
        var next_after = this.getNextIndex();
        if (prev_before === prev_after && !this.items[prev_after].classList.contains('is-visible'))
            this.items[prev_after].classList.add('is-visible');
        if (next_before === next_after && !this.items[next_after].classList.contains('is-visible'))
            this.items[next_after].classList.add('is-visible');
        if (prev_before !== index)
            this.items[prev_before].classList.remove('is-visible');
        if (!this.items[prev_after].classList.contains('is-visible'))
            this.items[prev_after].classList.add('is-visible');
        if (next_before !== index)
            this.items[next_before].classList.remove('is-visible');
        if (!this.items[next_after].classList.contains('is-visible'))
            this.items[next_after].classList.add('is-visible');
        this.items[this.activeIndex].classList.add('is-active'); // Add ActiveClass
    };
    ChilleLazy.prototype.addEvents = function () {
        var _this = this;
        if (this.count === 1 && this.nav)
            this.nav.classList.add('is-hidden');
        if (this.count > 1 && this.touchSupport) {
            var hideTips_1 = false;
            var hammerHook_1 = document.body;
            hammerHook_1.classList.add('show-touchevents-tips');
            var mc = new hammerjs_1.default.Manager(hammerHook_1, {
                touchAction: 'pan-y',
                inputClass: hammerjs_1.default.TouchInput
            });
            var swipe = new hammerjs_1.default.Swipe({
                threshold: 30
            });
            mc.add(swipe);
            mc.on('swipeleft swiperight', function (e) {
                if (e.type === 'swipeleft') {
                    if (!hideTips_1) {
                        hammerHook_1.classList.remove('show-touchevents-tips');
                        hideTips_1 = true;
                    }
                    _this.showNext();
                }
                if (e.type === 'swiperight') {
                    if (!hideTips_1) {
                        hammerHook_1.classList.remove('show-touchevents-tips');
                        hideTips_1 = true;
                    }
                    _this.showPrev();
                }
            });
        }
        if (this.prev)
            this.prev.addEventListener('click', this.showPrev.bind(this));
        if (this.next)
            this.next.addEventListener('click', this.showNext.bind(this));
    };
    ChilleLazy.prototype.lazyImage = function () {
        if (!this.items[this.activeIndex])
            return;
        if (!this.items[this.activeIndex].classList.contains('lazy'))
            this.items[this.activeIndex].classList.add('lazy');
        if (!this.items[this.getNextIndex()].classList.contains('lazy'))
            this.items[this.getNextIndex()].classList.add('lazy');
        if (!this.items[this.getPrevIndex()].classList.contains('lazy'))
            this.items[this.getPrevIndex()].classList.add('lazy');
        var images = document.querySelectorAll('.is-visible img.lazy-image:not(.lazy-image--handled)');
        function preloadImage(image) {
            var src = image.dataset.src;
            if (!src) {
                return;
            }
            applyImage(image, src);
        }
        function applyImage(img, src) {
            // Prevent this from being lazy loaded a second time.
            img.classList.add('lazy-image--handled');
            img.src = src;
        }
        if (images.length > 0) {
            images.forEach(function (image) {
                if (!image.classList.contains('lazy-image--handled')) {
                    preloadImage(image);
                }
            });
        }
    };
    ChilleLazy.prototype.getPrevIndex = function () {
        var previndex = this.activeIndex > 0 ? (this.activeIndex - 1) % this.count : this.count - 1;
        return previndex;
    };
    ChilleLazy.prototype.getNextIndex = function () {
        var nextindex = (this.activeIndex + 1) % this.count;
        return nextindex;
    };
    ChilleLazy.prototype.showPrev = function () {
        this.setActive(this.getPrevIndex());
    };
    ChilleLazy.prototype.showNext = function () {
        this.setActive(this.getNextIndex());
    };
    return ChilleLazy;
}());
exports.ChilleLazy = ChilleLazy;
exports.disableBody = function () {
    var page = document.querySelector('.kontakt-show');
    body_scroll_lock_1.disableBodyScroll(page);
};
var lazychille = new ChilleLazy();
var hoverGps = function () {
    jQuery('.places').on('mouseenter', '.is-active .place-gps', function () {
        this.previousElementSibling.classList.add('hover');
    });
    jQuery('.places').on('mouseleave', '.is-active .place-gps', function () {
        this.previousElementSibling.classList.remove('hover');
    });
};
exports.initChille = function () {
    exports.chille();
    lazychille;
    hoverGps();
    exports.disableBody();
};
